"use client"

import { getEventUrl } from "@/(admin)/modules/ui-builder/config/themes/tamda-one/EventCarousel/utils/utils"
import { t } from "@/languages/i18n"
import { DefaultImage } from "@/lib/external-components"
import { getLocalizedHref } from "@/lib/locale-utils"
import { formatDateSimpleYyyyMmDd } from "@/lib/utils"
import Image from "next/image"
import Link from "next/link"
import { EventItem } from "../EventCarousel/types"

export const EventCard = ({ event, locale }: { event: EventItem; locale?: string }) => {
  // Sự kiện được fetch theo locale hiện tại nên link cũng phải prefix as-needed,
  // nếu không thì đang ở /en bấm vào card sẽ rơi về URL tiếng Việt.
  const eventUrl = getLocalizedHref(locale, getEventUrl(event.name, event.id))

  const content = (
    <>
      <Link href={eventUrl} className="flex flex-col gap-3">
        <div className="relative sm:h-[280px] h-[220px] w-full overflow-hidden rounded-lg group">
          <Image
            src={
              event.coverUrl
                ? event.coverUrl
                : DefaultImage
            }
            alt={event.name || ""}
            fill
            className="object-cover rounded-lg w-full h-full group-hover:scale-105 transition-transform duration-300"
          />
        </div>
        <div className="flex flex-col gap-1">
          <div className="flex justify-between items-center uppercase">
            <p className="text-sm leading-[21.7px] font-bold text-[#37b24d]">{t("EVENT")}</p>
            <p className="text-sm leading-[21.7px] font-normal text-[#555555] italic">{formatDateSimpleYyyyMmDd(event.date)}</p>
          </div>
          <p className="text-lg leading-[27.9px] font-semibold text-[#333]">
            {event.name}
          </p>
          <p className="sm:text-base text-sm sm:leading-[20.8px] leading-[18.2px] font-normal text-[#333]">
            {event.shortDescription}
          </p>
        </div>
      </Link>
    </>
  )

  return (
    <div
      key={event.id}
      className="w-full "
    >
      {content}
    </div>
  )
}

export default EventCard
